import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/kefu.png'
import _imports_1 from '@/assets/images/kefuwechat.png'


const _hoisted_1 = { class: "global-customer-service" }
const _hoisted_2 = {
  key: 1,
  class: "contact-modal"
}
const _hoisted_3 = { class: "modal-header" }

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalCustomerService',
  setup(__props) {

const showModal = ref(true) // 默认显示弹窗

// 鼠标移入客服图标时显示弹窗
const handleMouseEnter = () => {
  showModal.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!showModal.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_0,
          alt: "客服",
          class: "service-button",
          onMouseenter: handleMouseEnter
        }, null, 32))
      : _createCommentVNode("", true),
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "modal-title" }, "联系我们", -1)),
            _createElementVNode("button", {
              class: "close-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = false))
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("svg", {
                class: "close-icon",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M19 12L5 12",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round"
                })
              ], -1)
            ]))
          ]),
          _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"modal-content\" data-v-21a09edb><div class=\"contact-item\" data-v-21a09edb><div class=\"contact-label\" data-v-21a09edb>电话咨询</div><div class=\"contact-value\" data-v-21a09edb>400-900-6269</div><div class=\"contact-time\" data-v-21a09edb>工作日：9:00-18:00（北京时间）</div></div><div class=\"contact-item\" data-v-21a09edb><div class=\"contact-label\" data-v-21a09edb>扫码咨询</div><div class=\"qr-code\" data-v-21a09edb><img src=\"" + _imports_1 + "\" alt=\"客服二维码\" data-v-21a09edb></div></div></div>", 1))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})